/*
Placeholder content still used where GET /ticket/{id}/ has no equivalent
field: the fault checkbox options and the Service tab's fixed option lists
(service type / outcome / approver choices, none of which the API returns as
an enum yet).
*/

export const FAULT_OPTIONS = [
  "Leakage",
  "Function",
  "Connectivity",
  "Station",
  "Suction",
  "Others",
];

/* ── Service tab ─────────────────────────────────────────────────────────── */

export const SERVICE_TAB = {
  serviceTypes: [
    "DOA",
    "In-Warranty",
    "Out-of-Warranty",
    "Accessories Only",
    "Quotation",
    "Others",
  ],
  faults: [
    "Leakage",
    "Function",
    "Connectivity",
    "Motor",
    "Suction",
    "Others",
  ],
  outcomes: [
    "Repair",
    "Credit",
    "Parts Replace Only",
    "Replace",
    "Quotation",
    "Maintenance Clean",
  ],
  statusToggles: [
    "Update Solvup",
    "Sent Notification",
    "Resolution Accepted",
  ],
  approvers: ["Dreame HQ", "Subemo AU", "Dreame CS", "Subemo CS"],
};

export default {
  FAULT_OPTIONS,
  SERVICE_TAB,
};
